import React, { useState } from 'react';

import {
  useSelectorActiveChain,
  useWebsocketEventListener,
} from 'components/hooks';

import WithdrawalResultModal from './WithdrawalResultModal';

/**
 * Deposit overlay is responsible for displaying modal on withdrawal TX being successuflly mined.
 *
 * This coomponent should be always mount on top level,
 * so it can fetch pending transaction informations.
 */
function WithdrawalBackgroundWorker() {
  const [transactions, setTransactions] = useState<string[]>([]);
  const { activeChain } = useSelectorActiveChain();

  useWebsocketEventListener('webclient', message => {
    const settledEvent = message.data;
    if (settledEvent.event !== 'transaction_settled') {
      return;
    }
    if (settledEvent.action !== 'withdraw') {
      return;
    }
    const { withdrawalId } = settledEvent.payload;
    if (withdrawalId) {
      setTransactions(state => [...state, withdrawalId]);
      return;
    }
  });
  return transactions[0] ? (
    <WithdrawalResultModal
      withdrawalId={transactions[0]}
      onClose={() => setTransactions(state => state.slice(1))}
      activeChain={activeChain}
    />
  ) : null;
}

export default WithdrawalBackgroundWorker;
